<!-- Маленькая ссылка на водителя с аватаром из инициалов -->
<template>
  <BaseTooltip position="top" max-width="320">
    <RouterLink
      class="driver-entity-link"
      :to="{ name: 'DriverDetails', params: { id: driver.id } }"
      :target="newTab ? '_blank' : undefined"
      :rel="newTab ? 'noopener noreferrer' : undefined"
      @click.stop
    >
      <span class="driver-entity-link__avatar">
        {{ initials }}
      </span>
      <span class="driver-entity-link__content">
        <span class="driver-entity-link__name">
          {{ driverName }}
        </span>
        <span v-if="subtitle" class="driver-entity-link__subtitle">
          {{ subtitle }}
        </span>
      </span>
    </RouterLink>

    <template #content>
      <div class="driver-entity-link-tooltip">
        <div class="driver-entity-link-tooltip__header">
          <span class="driver-entity-link-tooltip__avatar">
            {{ initials }}
          </span>
          <span class="driver-entity-link-tooltip__title">
            {{ driverName }}
          </span>
        </div>

        <div class="driver-entity-link-tooltip__rows">
          <div
            v-for="row in tooltipRows"
            :key="row.label"
            class="driver-entity-link-tooltip__row"
          >
            <span class="driver-entity-link-tooltip__label">
              {{ row.label }}
            </span>
            <span class="driver-entity-link-tooltip__value">
              {{ row.value }}
            </span>
          </div>
        </div>
      </div>
    </template>
  </BaseTooltip>
</template>

<script>
export default {
  name: "DriverEntityLink",
  props: {
    driver: {
      type: Object,
      required: true,
    },
    showSubtitle: {
      type: Boolean,
      default: false,
    },
    newTab: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    driverName() {
      return this.fullName || this.driver.selector_name || `Водитель #${this.driver.id}`;
    },

    fullName() {
      return [
        this.driver.last_name,
        this.driver.first_name,
        this.driver.middle_name,
      ].filter(Boolean).join(" ") || this.driver.full_name || "";
    },

    initials() {
      return this.driverName
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => word[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
    },

    subtitle() {
      if (!this.showSubtitle) return "";

      return this.driver.phone || "";
    },

    license() {
      return this.driver.driver_license || {};
    },

    licenseNumber() {
      return [this.license.series, this.license.number].filter(Boolean).join(" ");
    },

    licenseCategories() {
      const categories = this.license.categories;
      if (!Array.isArray(categories) || categories.length === 0) return "";

      return categories.join(", ");
    },

    tooltipRows() {
      return [
        { label: "Телефон", value: this.driver.phone || "—" },
        { label: "ИНН", value: this.driver.inn || "—" },
        { label: "ВУ", value: this.licenseNumber || "—" },
        { label: "Категории", value: this.licenseCategories || "—" },
      ];
    },
  },
};
</script>

<style scoped>
.driver-entity-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  min-width: 0;
  padding: 3px 5px;
  color: inherit;
  text-decoration: none;
  border-radius: 6px;
  vertical-align: middle;
}

.driver-entity-link:hover {
  background: #eef6f1;
}

.driver-entity-link__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  background: #64748b;
  border-radius: 50%;
}

.driver-entity-link__content {
  display: inline-flex;
  flex-direction: column;
  min-width: 0;
}

.driver-entity-link__name,
.driver-entity-link__subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.driver-entity-link__name {
  color: var(--color-dark);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
}

.driver-entity-link__subtitle {
  color: #64748b;
  font-size: 11px;
  line-height: 1.2;
}

.driver-entity-link-tooltip {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 230px;
}

.driver-entity-link-tooltip__header {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.driver-entity-link-tooltip__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  background: #64748b;
  border-radius: 50%;
}

.driver-entity-link-tooltip__title {
  min-width: 0;
  overflow: hidden;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
  text-overflow: ellipsis;
}

.driver-entity-link-tooltip__rows {
  display: grid;
  gap: 6px;
}

.driver-entity-link-tooltip__row {
  display: grid;
  grid-template-columns: 76px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
}

.driver-entity-link-tooltip__label {
  color: #cbd5e1;
  font-size: 11px;
  line-height: 1.25;
}

.driver-entity-link-tooltip__value {
  min-width: 0;
  overflow: hidden;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  text-overflow: ellipsis;
}
</style>
